import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type SetVariantsRequiresMarkingRequest as SchemaSetVariantsRequiresMarkingRequest } from '../schemas/SetVariantsRequiresMarkingRequest';
import { type SetVariantsRequiresMarkingStats as SchemaSetVariantsRequiresMarkingStats } from '../schemas/SetVariantsRequiresMarkingStats';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 * @summary Set or unset requires_marking flag for variants by query
 */
export const SetVariantsRequiresMarkingContentType = 'application/json' as const;
export type SetVariantsRequiresMarkingRequest = SchemaSetVariantsRequiresMarkingRequest;
export type SetVariantsRequiresMarkingResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful bulk update of requires_marking
     */
    '200': {
        'application/json': SchemaSetVariantsRequiresMarkingStats;
    };
};
export type SetVariantsRequiresMarkingResponseSuccess = SetVariantsRequiresMarkingResponses['200']['application/json'];
export type SetVariantsRequiresMarkingSearchParams = undefined;
export type SetVariantsRequiresMarkingPathParameters = undefined;
export const SetVariantsRequiresMarkingUrl = '/variants/requires-marking' as const;
export const SetVariantsRequiresMarkingMethod = 'POST' as const;
export const getSetVariantsRequiresMarkingUrl = (_params?: SetVariantsRequiresMarkingPathParameters) =>
    SetVariantsRequiresMarkingUrl;
